import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LearnerProficiencyChart from '@/components/charts/learner-proficiency-chart/learner-proficiency-chart';
import SubjectInfoPanel from '@/components/proficiency/subject-info-panel/subject-info-panel';
import DomainsListPanel from '@/components/proficiency/domains-list-panel/domains-list-panel';
import DomainInfoPanel from '@/components/proficiency/domain-info-panel/domain-info-panel';
import TopicInfoPanel from '@/components/proficiency/topic-info-panel/topic-info-panel';
import CompetencyInfoPanel from '@/components/proficiency/competency-info-panel/competency-info-panel';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MonthYearPicker from '@/components/selector/month-year-picker/month-year-picker';
import { SubjectModel } from '@/models/taxonomy/subject';
import { DomainModel } from '@/models/proficiency/domain';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { CompetencyModel } from '@/models/proficiency/competency';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';
import axios from 'axios';
import moment from 'moment';
import { RGDomainModel } from '@/models/proficiency/route-generator';
import ShowcaseEditLayoutComponent from '@/components/showcase/showcase-edit-layout/showcase-edit-layout';
import MarkerListPanelComponent from '@/components/showcase/marker-list-panel/marker-list-panel';
import { UserClassModel } from '@/models/class/class';
import { markersAPI } from '@/providers/apis/markers/markers';
import { RouteMilestoneModel } from '@/models/marker/reroute';
import { MarkerListModel } from '@/models/marker/marker-list';
import MilestoneViewComponent from '@/components/showcase/milestone-view/milestone-view';
import { MarkerBoundaryModel } from '@/models/marker/marker';

@Component({
  name: 'learner-proficiency',
  components: {
    'learner-proficiency-chart': LearnerProficiencyChart,
    'domains-list-panel': DomainsListPanel,
    'google-material-icon': GoogleMaterialIcon,
    'subject-info-panel': SubjectInfoPanel,
    'month-year-picker': MonthYearPicker,
    'domain-info-panel': DomainInfoPanel,
    'competency-info-panel': CompetencyInfoPanel,
    TopicInfoPanel,
    'showcase-layout': ShowcaseEditLayoutComponent,
    'marker-card': MarkerListPanelComponent,
    'milestone-view': MilestoneViewComponent,
  },
})
export default class LearnerProficiency extends Vue {

  get subjectCode() {
    return this.activeSubject ? this.activeSubject.code : 'K12.MA';
  }

  private categories!: ClassificationModel[];

  private subjects!: SubjectModel[];

  private activeToggleList: string = '';

  private isShowRouteLine: boolean = false;

  @Prop()
  private defaultCategoryId: any;

  @Prop()
  private classificationCode!: string;

  @Prop()
  private defaultSubjectCode: any;

  @Prop()
  private classification!: ClassificationModel;

  @Prop()
  private activeCategory!: ClassificationModel;

  @Prop()
  private activeSubject!: SubjectModel | any;

  private isShowCategories: boolean = false;

  private isShowSubjects: boolean = false;

  @Prop()
  private activeTimeline!: string;

  @Prop()
  private userId!: string;

  @Prop()
  private isActiveProficiency?: boolean;

  @Prop()
  private learner: any;

  private activeDomainInfo: Domain | null = null;

  private activeDomainSeq?: number = 0;

  private isShowDomainInfo: boolean = false;

  private portfolioDomain: any = [];

  private activeTopic: Topic | null = null;

  private activeCompetency: CompetencyModel | any = null;

  private activeCompetencySeq!: number;

  private isShowCompetencyPanel: boolean = false;

  private isShowTopicInfoPanel: boolean = false;

  private rgDomains: RGDomainModel[] = [];

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  private chartData: any = [];

  private showcaseCompetency: any = null;

  private isEditShowcase: boolean = false;

  private isShowMarker: boolean = false;

  private isShowJourney: boolean = false;

  private markerList: MarkerListModel[] = [];

  private markerSearchTerms: string = '';

  @Prop()
  private userClassList!: UserClassModel[];

  @Prop()
  private isShowcasePage!: boolean;

  private generateRouteList: RouteMilestoneModel[] = [];

  private isJourneyLoaded: boolean = false;

  private enableShowCase: boolean = false;

  private enableMarker: boolean = true;

  private activeMarker: MarkerListModel = {} as MarkerListModel;

  private markerBoundaries: MarkerBoundaryModel[] = [];

  private isChartLoading: boolean = false;

  private get activeClasses() {
    return this.userClassList.filter((item) => item.subject === this.subjectCode);
  }

  private get isLevelContent() {
    return this.activeToggleList && this.activeToggleList !== '';
  }

  public created() {
    if (!this.isActiveProficiency) {
      this.activeToggleList = 'ShowPortfolioContainer';
    }
    this.loadTaxonomyData();
    this.searchMarkers();
  }

  public onSelectCategory(category: ClassificationModel) {
    const component = this;
    component.activeCategory = category;
    component.fetchTaxonomySubjects(category.id).then((taxonomySubjects: SubjectModel[]) => {
      component.subjects = taxonomySubjects;
      component.activeSubject = taxonomySubjects.find(
        (subject: SubjectModel) => component.defaultSubjectCode === subject.code);
    });
    component.isShowCategories = false;
  }

  public onSelectSubject(subject: SubjectModel) {
    const component = this;
    component.activeSubject = subject;
    component.isShowSubjects = false;
  }

  public onChageTimeline(timeline: string) {
    this.activeTimeline = timeline;
  }

  public loadTaxonomyData() {
    const component = this;
    // axios.all([
    //   taxonomyAPI.fetchTaxonomyClassifications(),
    //   component.fetchTaxonomySubjects(),
    // ]).then(axios.spread((subjectClassifications: any, taxonomySubjects: any) =>  {
    //   component.categories = subjectClassifications;
    //   component.subjects = taxonomySubjects;
    //   component.activeSubject = taxonomySubjects.find((subject: any) =>
    //     subject.code === component.defaultSubjectCode,
    //   );
    //   component.activeCategory = subjectClassifications.find(
    //     (category: any) => category.id === component.defaultCategoryId,
    //   );
    // }));
  }

  private onSelectDomain(domain: Domain) {
    const hasMoreDomain = this.chartData.find((item: any) => item.isExpanded);
    this.activeDomainInfo = this.chartData.find((item: any) => item.domainCode === domain.domainCode);
    this.activeDomainSeq = domain.domainSeq;
    if (!hasMoreDomain) {
      this.isShowDomainInfo = true;
      this.activeToggleList = 'ShowDomainList';
    }

    // console.log('check inside select domain');
  }

  private onToggleDomain(domain: Domain) {
    this.activeDomainInfo = domain;
    this.activeDomainSeq = domain.domainSeq;
    this.isShowDomainInfo = true;
    this.activeToggleList = 'ShowDomainList';
  }

  private onSelectTopic(topic: Topic) {
    this.activeTopic = topic;
    this.isShowTopicInfoPanel = true;
    this.isShowDomainInfo = false;
    this.isShowRouteLine = false;
  }

  private onSelectPortfolioStat(portfolio: Domain) {
    this.activeDomainInfo = this.chartData.find((domain: any) => domain.domainCode === portfolio.domainCode);
    this.activeDomainSeq = portfolio.domainSeq;
    this.isShowDomainInfo = true;
    this.activeToggleList = 'ShowPortfolioContainer';
  }

  private onSelectCompetency(competency: CompetencyModel) {
    this.isShowDomainInfo = false;
    this.isShowTopicInfoPanel = false;
    this.isShowCompetencyPanel = true;
    this.activeCompetencySeq = competency.competencySeq;
    this.activeCompetency = competency;
    this.isShowRouteLine = false;
  }

  private onSelectLearnerCompetency(competency: CompetencyModel) {
   this.onSelectCompetency(competency);
   this.activeToggleList = '';
  }


  private onCloseDomainInfoPanel() {
    this.isShowDomainInfo = false;
    this.activeDomainSeq = 0;
    this.activeDomainInfo = null;
    if (!this.chartData.find((item: any) => item.isExpanded)) {
      this.isShowCompetencyPanel = false;
    }
  }

  private onCloseTopicInfoPanel() {
    this.isShowTopicInfoPanel = false;
    this.isShowCompetencyPanel = false;
    this.activeTopic = null;
    if (this.activeDomainInfo) {
      this.isShowDomainInfo = true;
    }
  }

  private onCloseCompetencyInfoPanel() {
    this.isShowCompetencyPanel = false;
    if (this.activeDomainInfo && !this.activeTopic) {
      this.isShowDomainInfo = true;
    } else if (this.activeTopic) {
      this.isShowTopicInfoPanel = true;
    }
  }

  private onloadedChartData(chartData: any) {
    this.chartData = chartData;
    this.portfolioDomain = chartData;
  }

  private backAction() {
    this.$emit('backAction');
  }

  private onSelectRoute(rgDomains: RGDomainModel[]) {
    this.rgDomains = rgDomains;
  }

  private onShowRouteLine(isShowRouteLine: boolean) {
        this.isShowRouteLine = isShowRouteLine;
  }

  private onSelectShowcase(competency: any) {
    this.isEditShowcase = true;
    this.showcaseCompetency = competency;
  }

  private onClosePullup() {
    this.isEditShowcase = false;
  }

  private onShowMarker() {
    this.isShowMarker = !this.isShowMarker;
    this.enableMarker = false;
  }

  private onGenerateRoute(marker: any) {
    this.isShowJourney = true;
    this.isJourneyLoaded = false;
    this.activeMarker = marker;
    this.generateMakerRoute(marker);
    this.enableShowCase = true;
    this.loadChartTimer(true);
  }

  private onCloseMarker() {
    this.isShowJourney = false;
    this.enableShowCase = false;
    this.activeMarker = null as any;
    this.loadChartTimer(false);
  }

  private onGoBack() {
    this.enableShowCase = false;
    if (this.isShowJourney) {
      this.isShowJourney = false;
      this.loadChartTimer(false);
    } else {
      this.activeMarker = null as any;
      this.isShowMarker = false;
      this.enableMarker = true;
    }
  }

  private onChangeContent(product: any) {
    const marker = this.activeMarker;
    this.generateMakerRoute(marker, product);
  }

  private fetchTaxonomySubjects(subjectId: string = '') {
    const component = this;
    return taxonomyAPI.fetchTaxonomySubjects(subjectId || component.defaultCategoryId);
  }

  private onShowRouteInfo(marker: any) {
    this.activeMarker = marker;
  }

  private onSearchMarker(terms: string) {
    this.markerSearchTerms = terms;
    this.searchMarkers();
  }

  // ----------------------------------------------------------
  // Methods

  private generateMakerRoute(marker: any, product: any = null) {
    const params: any = {
      subject: marker.subject.subjectCode,
      marker: marker.id,
      user: this.userId,
      framework: 'TMA',
    };

    if (product) {
      params.product_id = [product.productId];
    }
    this.isJourneyLoaded = false;
    this.generateRouteList = [];
    markersAPI.generateMarker(params).then(() => {
      if (params.product_id) {
        params.product_id = params.product_id.join(',');
      }
      markersAPI.fetchRerouteContent(params).then((routeData) => {
        this.generateRouteList = routeData;
        this.isJourneyLoaded = true;
       });
    });
  }

  private searchMarkers() {
    const params: any = {
      filters: {
       'txFramework.fwCode': 'TMA',
        'txSubject.txSubjectCode': this.subjectCode,
      },
    };
    if (this.markerSearchTerms) {
      params.query = this.markerSearchTerms;
    }
    markersAPI.searchMarkers(params).then((markerList) => {
      this.markerList = markerList;
    });
  }

  private loadChartTimer(isLoaded: boolean) {
    setTimeout(() => this.isChartLoading = isLoaded, 1000);
  }


}
